import * as c from '@chakra-ui/react'
import { TranslateOptions, translateText } from 'src/utils/translateText'

import { ArrowRightIcon } from '../icons/arrow-right.icon'

interface SalesProps {
  salesBanner: {
    title: TranslateOptions
    subtitle: TranslateOptions
    profile: TranslateOptions
    description: TranslateOptions
    cta: TranslateOptions
    url: string
    items: CardSalesProps[]
    idSection?: string
  }
}

interface CardSalesProps {
  image: string
  salesTime: TranslateOptions
  totalSold: string
  incorp: string
  address: {
    city: string
    state: string
  }
}

export default function Sales({ salesBanner }: SalesProps) {
  const desktopBg =
    'linear-gradient(90deg, rgba(77, 85, 96, 1) 19%, rgba(121, 127, 136, 1) 58%, rgba(255,255,255,1) 58%)'
  const mobileBg =
    'linear-gradient(180deg, rgba(255,255,255,1) 37%, rgba(121, 127, 136, 1) 37%, rgba(77, 85, 96, 1) 72%)'

  return (
    <c.Container px={['s5', 0]} id={salesBanner?.idSection}>
      <c.Box
        bgImage={[mobileBg, desktopBg]}
        p={['s5', 'l2']}
        h={['full', '504px']}
        position="relative"
        borderRadius="20px"
      >
        <c.Flex
          h={['100%', '424px']}
          w={['100%', '1120px']}
          position={['initial', 'absolute']}
          direction={['column-reverse', 'row']}
          align="center"
          justify="space-between"
          gap="l2"
        >
          <c.Flex
            h={['100%', '424px']}
            w={['100%', '720px']}
            flexWrap="wrap"
            direction={['column', 'row']}
            justify="space-between"
            gap="s5"
          >
            {salesBanner?.items?.map((item, i) => (
              <CardSales {...item} key={i} />
            ))}
          </c.Flex>

          <c.Box maxW={['full', '342px']}>
            <c.Text
              color="black.300"
              fontSize="t-sm.0"
              fontWeight="bold"
              textTransform="uppercase"
            >
              {translateText(salesBanner?.profile)}
            </c.Text>
            <c.Heading fontSize="h-lg.0">
              {translateText(salesBanner?.subtitle)}
            </c.Heading>
            <c.Heading
              color="primary.500"
              fontSize="h-xl.1"
              textTransform="uppercase"
            >
              {translateText(salesBanner?.title)}
            </c.Heading>
            <c.Text fontSize="t-md.1" my="m3">
              {translateText(salesBanner?.description)}
            </c.Text>
            <c.Button
              as={c.Link}
              isExternal
              href={salesBanner?.url}
              variant="primary"
              fontSize="t-md.0"
              borderRadius="full"
              rightIcon={
                <c.Icon as={ArrowRightIcon} color="black.0" h="12px" w="12px" />
              }
            >
              {translateText(salesBanner?.cta)}
            </c.Button>
          </c.Box>
        </c.Flex>
      </c.Box>
    </c.Container>
  )
}

function CardSales(props: CardSalesProps) {
  return (
    <c.Box h={['full', '202px']} w={['full', '350px']}>
      <c.Box
        position="relative"
        h="160px"
        bgImage={props.image}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="cover"
        borderRadius="20px 20px 0 0"
      >
        <c.Box
          position="absolute"
          top={4}
          left={4}
          py="s1"
          px="s3"
          maxW="fit-content"
          bg="black.0"
          borderRadius="8px"
        >
          <c.Heading color="black.600" fontSize="h-md.0">
            {`${props.totalSold} ${translateText({
              ptBr: 'Vendido',
              en: 'Sold',
            })}`}
          </c.Heading>
          <c.Text color="black.600" fontSize="t-sm.0" fontWeight="bold">
            {translateText(props.salesTime)}
          </c.Text>
        </c.Box>
      </c.Box>

      <c.Flex
        py="s1"
        px="s4"
        h="44px"
        bg="black.0"
        borderRadius="0 0 20px 20px"
        align="center"
        shadow="lg"
      >
        <c.Text color="black.400" fontSize="t-sm.0">
          {`${props.incorp} | ${props.address.city} - `}
          <c.Box as="span" textTransform="uppercase">
            {props.address.state}
          </c.Box>
        </c.Text>
      </c.Flex>
    </c.Box>
  )
}
